import { useAccount, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { getMslToken } from "./useAuth";

export const useGetToken = () => {
  const [token, setToken] = React.useState("");
  const { instance, accounts } = useMsal();
  const account: any = useAccount(accounts[0] || {});

  const getToken = async () => {
    let tokenResponse = await getMslToken();
    setToken(tokenResponse);
  };

  useEffect(() => {
    if (account && account.username) getToken();
  }, [account, instance]);

  return token;
};
